import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
import { openDemoMail } from '../lib/mailto';
export function Nav() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = ['About', 'Services', 'How It Works', 'Partners', 'Demo'];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'py-4' : 'py-6'}`} data-id="element-152">
      <div className="max-w-7xl mx-auto px-6" data-id="element-153">
        <div className={`flex items-center justify-between rounded-full transition-all duration-500 ${isScrolled ? 'glass-panel px-6 py-3' : 'px-2 py-2'}`} data-id="element-154">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2.5" data-id="element-155">
            <img src="https://cdn.magicpatterns.com/uploads/nrutqAxUPjySDmYrV6bARm/munisverse.png" alt="MUNISVerse" className="w-9 h-9 rounded-full object-cover" data-id="element-156" />
            <span className="font-display font-semibold text-xl tracking-tight" data-id="element-157">
              MUNISVerse
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-158">
            {navLinks.map(link => <a key={link} href={`#${link.toLowerCase().replace(/\s+/g, '-')}`} className="text-sm font-medium text-zinc-400 hover:text-white transition-colors" data-id="element-159">
                {link}
              </a>)}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:block" data-id="element-160">
            <Button variant={isScrolled ? 'primary' : 'secondary'} className="py-2.5 px-5" onClick={openDemoMail} data-id="element-161">
              Book a Tour
            </Button>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden p-2 text-zinc-400 hover:text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-162">
            {mobileMenuOpen ? <X size={24} data-id="element-163" /> : <Menu size={24} data-id="element-164" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-4 right-4 mt-2 glass-panel rounded-2xl p-6 flex flex-col gap-4" data-id="element-165">
          {navLinks.map(link => <a key={link} href={`#${link.toLowerCase().replace(/\s+/g, '-')}`} className="text-lg font-medium text-zinc-300 hover:text-white py-2 border-b border-white/5" onClick={() => setMobileMenuOpen(false)} data-id="element-166">
              {link}
            </a>)}
          <Button variant="primary" className="mt-4 w-full" onClick={() => {
        setMobileMenuOpen(false);
        openDemoMail();
      }} data-id="element-167">
            Book a Tour
          </Button>
        </div>}
    </header>;
}